export enum EdifyContentUnitType {
  Theory = "THEORY",
  Flashcards = "DRILLING",
}
